import Layout from '@/layout';
var territorialDistributorRouter = {
  path: '/territorialDistributor',
  component: Layout,
  redirect: '/territorialDistributor/setting',
  name: 'TerritorialDistributor',
  alwaysShow: true,
  meta: {
    title: '区域代理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/territorialDistributor/list/index');
    },
    name: 'TerritorialDistributorList',
    meta: {
      title: '区域代理列表'
    }
  }, {
    path: 'apply',
    component: function component() {
      return import('@/views/territorialDistributor/apply/index');
    },
    name: 'TerritorialDistributorApply',
    meta: {
      title: '入驻申请'
    }
  }, {
    path: 'reward',
    component: function component() {
      return import('@/views/territorialDistributor/reward/index');
    },
    name: 'TerritorialDistributorReward',
    meta: {
      title: '区域奖励列表'
    }
  }, {
    path: 'setting',
    component: function component() {
      return import('@/views/territorialDistributor/setting/index');
    },
    name: 'TerritorialDistributorSetting',
    meta: {
      title: '基础设置'
    }
  }]
};
export default territorialDistributorRouter;